module.exports = __webpack_public_path__ + "static/media/007-boy-1.d9d6abe8.svg";